// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"806":"user","933":"auth","945":"dashboard","962":"home"}[chunkId] || chunkId) + "." + {"399":"a4d14817","806":"2bd99aab","933":"33c1a6e9","945":"bb0c6ae1","962":"efc8fcac"}[chunkId] + ".css";
};